import { IWorkingHours } from '@dataTypes/clinic.type'
import { ISettings } from '@dataTypes/settings.type'
import { DAY_ORDER } from '@utils/phoneManagement.utils'

export const SETTINGS_NAV_ITEMS: ISettings[] = [
  {
    id: 'practice-settings',
    name: 'Practice',
    description: 'Practice Settings',
    icon: 'mgc_dental_fill',
    items: [
      {
        id: 'practice-clinic-info',
        name: 'Clinic information',
        description: 'View and manage clinic information',
      },
      {
        id: 'practice-opening-hours',
        name: 'Opening hours',
        description: 'View and manage opening hours',
      },
      {
        id: 'practice-room-operatories',
        name: 'Room operatories',
        description: 'View and manage room & operatories',
      },
      {
        id: 'practice-tax-and-legal',
        name: 'Tax & legal',
        description: 'View and manage tax & legal information',
      },
    ],
  },
  {
    id: 'staff-settings',
    name: 'Team',
    description: 'Team Settings',
    icon: 'mgc_group_3_fill',
    items: [
      {
        id: 'staff-list',
        name: 'Staff list',
        description: 'View and manage staff list',
      },
      {
        id: 'staff-work-sched',
        name: 'Work schedule',
        description: 'View and manage staff work schedule',
      },
      {
        id: 'staff-permissions',
        name: 'Permissions',
        description: 'Manage permissions of each team member',
      },
    ],
  },
  {
    id: 'clinical-settings',
    name: 'Clinical',
    description: 'Clinical Settings',
    icon: 'mgc_stethoscope_fill',
    items: [
      {
        id: 'clinical-procedure',
        name: 'Procedure codes',
        description: 'View and manage clinical procedure',
      },
      {
        id: 'clinical-bundled-procedures',
        name: 'Bundled & favorite procedures',
        description: 'View and manage clinical bundled procedures',
      },
      {
        id: 'clinical-charting-preference',
        name: 'Charting preferences',
        description: 'View and manage clinical charting preferences',
      },
      {
        id: 'clinical-patient-form-groups',
        name: 'Patient Forms',
        description: 'Forms patients sign after kiosk registration',
      },
      // {
      //   id: 'clinical-treatment-plan',
      //   name: 'Treatment plan',
      //   description: 'View and manage clinical treatment plan',
      // },
      {
        id: 'clinical-dicom-capture',
        name: 'DICOM Capture',
        description: 'Manage DICOM capture devices & watch folders',
      },
    ],
  },
  {
    id: 'communications-settings',
    name: 'Communications',
    description: 'Communications Settings',
    icon: 'mgc_message_4_fill',
    items: [
      {
        id: 'comm-phone-management',
        name: 'Phone management',
        description: 'Manage clinic phone numbers',
      },
      {
        id: 'comm-ai-receptionist',
        name: 'AI receptionist',
        description: 'Set up the phone receptionist for this clinic',
      },
      {
        id: 'comm-call-flow',
        name: 'Communication flow',
        description: 'Setup call and SMS flows for your clinic',
      },

      {
        id: 'comm-call-block',
        name: 'Call blocking',
        description: 'Setup blocking rules for your clinic',
      },
      {
        id: 'comm-call-record',
        name: 'Call recording',
        description: 'Manage clinic call recording',
      },
      {
        id: 'comm-devices',
        name: 'Devices',
        description: 'Manage clinic devices',
      },
      {
        id: 'comm-messaging',
        name: 'Messaging',
        description: 'Manage clinic messaging',
      },
      {
        id: 'comm-email',
        name: 'Email',
        description: 'Manage clinic email',
      },
      {
        id: 'comm-fax',
        name: 'Fax',
        description: 'Manage clinic fax',
      },
    ],
  },
  {
    id: 'accounting-settings',
    name: 'Insurance & payments',
    description: 'Insurance & payments Settings',
    icon: 'mgc_currency_dollar_fill',
    items: [
      {
        id: 'accounting-carrier',
        name: 'Carrier',
        description: 'View and manage carrier',
      },
      {
        id: 'accounting-fee-schedule',
        name: 'Fee schedule',
        description: 'View and manage fee schedule',
      },
      {
        id: 'accounting-discounts',
        name: 'Discounts',
        description: 'View and manage discounts',
      },
      {
        id: 'accounting-adjustments',
        name: 'Adjustments',
        description: 'View and manage adjustments',
      },
      {
        id: 'accounting-membership',
        name: 'Membership',
        description: 'View and manage membership',
      },
      {
        id: 'accounting-integrations',
        name: 'Accounting',
        description: 'View and manage accounting integrations',
      },
    ],
  },
  {
    id: 'reporting-settings',
    name: 'Analytics',
    description: 'Reporting Settings',
    icon: 'mgc_profile_fill',
    items: [
      {
        id: 'reporting-dashboard',
        name: 'Dashboard',
        description: 'View and manage dashboard',
      },
      {
        id: 'reporting-goals',
        name: 'Goals',
        description: 'View and manage goals',
      },
    ],
  },
  {
    id: 'system-settings',
    name: 'System',
    description: 'System Settings',
    icon: 'mgc_settings_6_fill',
    items: [
      {
        id: 'practice-scheduler',
        name: 'Scheduler',
        description: 'View and manage scheduler settings',
      },
      {
        id: 'system-backup',
        name: 'Backup',
        description: 'View and manage backup',
      },
      {
        id: 'system-cloud-storage',
        name: 'Cloud storage',
        description: 'View and manage cloud storage',
      },
      {
        id: 'system-appearance',
        name: 'Appearance',
        description: 'Choose light, dark, or system theme',
      },
    ],
  },
]

export const US_STATE = [
  { value: 'AL', label: 'AL' },
  { value: 'AK', label: 'AK' },
  { value: 'AZ', label: 'AZ' },
  { value: 'AR', label: 'AR' },
  { value: 'CA', label: 'CA' },
  { value: 'CO', label: 'CO' },
  { value: 'CT', label: 'CT' },
  { value: 'DE', label: 'DE' },
  { value: 'FL', label: 'FL' },
  { value: 'GA', label: 'GA' },
  { value: 'HI', label: 'HI' },
  { value: 'ID', label: 'ID' },
  { value: 'IL', label: 'IL' },
]

export const REPORT_PREFERENCES = [
  { label: 'Adjustments', value: 'adjustments' },
  { label: 'Appointments', value: 'appointments' },
  { label: 'Broken Appointments', value: 'brokenAppointments' },
  { label: 'Procedures', value: 'procedures' },
  { label: 'Active Patients', value: 'activePatients' },
  { label: 'New Patients', value: 'newPatients' },
  { label: 'Birthdays', value: 'birthdays' },
  { label: 'Discount Plans', value: 'discountPlans' },
  { label: 'Insurance Plans', value: 'insurancePlans' },
  {
    label: 'Procedure Codes - Fee Schedules',
    value: 'procedureCodesFeeSchedules',
  },
  { label: 'Referral Analysis', value: 'referralAnalysis' },
  { label: 'Payments', value: 'payments' },
  { label: 'Patient Notes', value: 'patientNotes' },
  { label: 'Prescriptions', value: 'prescriptions' },
]

export const ACCESS_REQUEST = [
  {
    value: 'Full',
    label: 'Full',
  },
  {
    value: 'None',
    label: 'None',
  },
  {
    value: 'Limited',
    label: 'Limited',
  },
]

export const TICKER_OPTIONS = [
  {
    label: "Prior Day's Production",
    value: 'priorDaysProduction',
    ticked: true,
  },
  {
    label: 'Active Hygiene Patients',
    value: 'activeHygienePatients',
    ticked: true,
  },
  {
    label: "Today's Scheduled Production",
    value: 'todaysScheduledProduction',
    ticked: true,
  },
  {
    label: 'Hygiene Pre-Appointment %',
    value: 'hygienePreAppointmentPercentage',
    ticked: false,
  },
  {
    label: "Tomorrow's Scheduled Production",
    value: 'tomorrowsScheduledProduction',
    ticked: false,
  },
  { label: 'Perio Patient %', value: 'perioPatientPercentage', ticked: false },
  { label: 'Future Visits', value: 'futureVisits', ticked: false },
  { label: 'New Patients YTD', value: 'newPatientsYTD', ticked: false },
  { label: 'Production Per Visit', value: 'productionPerVisit', ticked: false },
  { label: 'Production YTD', value: 'productionYTD', ticked: false },
  { label: 'Active Patients', value: 'activePatients', ticked: false },
  { label: 'Collection YTD', value: 'collectionYTD', ticked: false },
  {
    label: 'Pre-Appointment %',
    value: 'preAppointmentPercentage',
    ticked: false,
  },
]

export const CLINICAL_HOURS_OPTIONS = [
  'All',
  'General Dentist',
  'Hygienist',
  'Dental Assistant',
]

export const OCCURENCES = {
  sunday: [
    {
      value: 'every-sunday',
      label: 'Every Sunday',
    },
    {
      value: 'every-other-sunday',
      label: 'Every Other Sunday',
    },
  ],

  monday: [
    {
      value: 'every-monday',
      label: 'Every Monday',
    },
    {
      value: 'every-other-monday',
      label: 'Every Other Monday',
    },
  ],
  tuesday: [
    {
      value: 'every-tuesday',
      label: 'Every Tuesday',
    },
    {
      value: 'every-other-tuesday',
      label: 'Every Other Tuesday',
    },
  ],
  wednesday: [
    {
      value: 'every-wednesday',
      label: 'Every Wednesday',
    },
    {
      value: 'every-other-wednesday',
      label: 'Every Other Wednesday',
    },
  ],
  thursday: [
    {
      value: 'every-thursday',
      label: 'Every Thursday',
    },
    {
      value: 'every-other-thursday',
      label: 'Every Other Thursday',
    },
  ],
  friday: [
    {
      value: 'every-friday',
      label: 'Every Friday',
    },
    {
      value: 'every-other-friday',
      label: 'Every Other Friday',
    },
  ],
  saturday: [
    {
      value: 'every-saturday',
      label: 'Every Saturday',
    },
    {
      value: 'every-other-saturday',
      label: 'Every Other Saturday',
    },
  ],
}

export const ADJUSTMENTS_TYPES = [
  { label: 'All', value: 'all' },
  { label: 'Sales Tax', value: 'sales-tax' },
  { label: 'Professional Discount', value: 'professional-discount' },
  { label: 'Cash Discount', value: 'cash-discount' },
  { label: 'Misc Neg Adjustment', value: 'misc-neg-adjustment' },
  { label: 'Misc Pos Adjustment', value: 'misc-pos-adjustment' },
  { label: '10 Referral Discount', value: '10-referral-discount' },
  {
    label: 'Broken Appointment - No Show',
    value: 'broken-appointment-no-show',
  },
  {
    label: 'Broken Appointment w/o 24 Hrs Notice',
    value: 'broken-appointment-w-o-24-hrs-notice',
  },
  { label: 'Returned Check Fee', value: 'returned-check-fee' },
  { label: 'NSF Fee', value: 'nsf-fee' },
  { label: 'Finance Charge', value: 'finance-charge' },
  { label: '5% Cash Discount', value: '5%-cash-discount' },
  { label: '10% Senior Discount', value: '10%-senior-discount' },
  { label: 'New Patient Discount', value: 'new-patient-discount' },
  { label: 'Discount', value: 'discount' },
  { label: 'Billing Charge', value: 'billing-charge' },
]

export const BILLING_TYPES = [
  { label: 'All', value: 'all' },
  { label: 'Standard', value: 'standard' },
  { label: 'Insured', value: 'insured' },
  { label: 'Uninsured', value: 'uninsured' },
  { label: 'Friends/Family', value: 'friends-family' },
  { label: 'Bad Debt - Precollections', value: 'bad-debt-precollections' },
  {
    label: 'Bad Debt - Sent to Collections',
    value: 'bad-debt-sent-to-collections',
  },
  { label: 'Forgotten Balances', value: 'forgotten-balances' },
]

export const AGE_OF_AGING = [
  { label: 'Any Balance', value: 'any-balance' },
  { label: 'Over 30 Days', value: 'over-30-days' },
  { label: 'Over 60 Days', value: 'over-60-days' },
  { label: 'Over 90 Days', value: 'over-90-days' },
]

export const CLAIM_FILTER = [
  { label: 'All', value: 'all' },
  { label: 'Primary', value: 'primary' },
  { label: 'Secondary', value: 'secondary' },
  { label: 'Holding', value: 'holding' },
]

export const AGE_WRITE_OFF_BY = [
  { label: 'Insurance Payment Date', value: 'insurance-payment-date' },
  { label: 'Procedure Date', value: 'procedure-date' },
  {
    label: 'Initial claim date for est. Ins pay date for adj.',
    value: 'initial-claim-date-for-est-ins-pay-date-for-adj',
  },
]

export const NEGATIVE_BALANCES = [
  { label: 'Exclude', value: 'exclude' },
  { label: 'Include', value: 'include' },
  { label: 'Show Only', value: 'show-only' },
]

export const CUSTOM_AGING_INCLUDE_CHCKBX = [
  { label: 'Procedure Fees', value: 'procedure-fees' },
  { label: 'Adjustments', value: 'adjustments' },
  { label: 'Pay Plan Charges', value: 'pay-plan-charges' },
  { label: 'Pay Plan Credits', value: 'pay-plan-credits' },
  { label: 'Patient Payments', value: 'patient-payments' },
  { label: 'Insurance Payments', value: 'insurance-payments' },
  {
    label: 'Insurance Estimates',
    value: 'insurance-estimates',
  },
  { label: 'Write-offs', value: 'write-offs' },
  {
    label: 'Write-off Estimates',
    value: 'write-off-estimates',
  },
]

export const CUSTOM_AGING_EXCLUDE_CHCKBX = [
  {
    label: 'Exclude inactive patients',
    value: 'exclude-inactive-patients',
    include: false,
  },
  {
    label: 'Exclude archived patients',
    value: 'exclude-archived-patients',
    include: false,
  },
  {
    label: 'Exclude bad addresses',
    value: 'exclude-bad-addresses',
    include: false,
  },
]

export const OS_DATE_RANGE = [
  { label: 'Date Sent', value: 'date-sent' },
  { label: 'Date Sent Orig', value: 'date-sent-orig' },
  { label: 'Date of Service', value: 'date-of-service' },
]

export const PREAUTH_OPTIONS = [
  { label: 'Including Preauths', value: 'including-preauths' },
  { label: 'Excluding Preauths', value: 'excluding-preauths' },
  { label: 'Only Show Preauths', value: 'only-show-preauths' },
]

export const FOR_USERS = [
  { label: 'All', value: 'all' },
  { label: 'Unassigned', value: 'unassigned' },
  { label: 'Admin', value: 'admin' },
  { label: 'Doctor', value: 'doctor' },
  { label: 'User', value: 'user' },
]

export const LAST_TRACKING_STATUS = [
  { label: 'All', value: 'all' },
  { label: 'Resubmitted', value: 'resubmitted' },
]

export const CARRIER = [
  { label: 'All', value: 'all' },
  { label: 'Blue Shield', value: 'blue-shield' },
  { label: 'Delta Insurance', value: 'delta-insurance' },
]

export const AGING_AR_CHCKBX = [
  { label: 'Age write-off estimates', value: 'age-write-off-estimates' },
  {
    label: 'Show last payment date (landscape)',
    value: 'show-last-payment-date-landscape',
  },
  { label: 'Exclude income transfers', value: 'exclude-income-transfers' },
]

export const AGING_AR_CHCKBX_2 = {
  excludePatientsWith: [
    { label: 'Inactive status', value: 'inactive-status' },
    { label: 'Archived status', value: 'archived-status' },
    { label: 'Bad Addresses (No Zipcode)', value: 'bad-addresses-no-zipcode' },
  ],
  includePatientsWith: [
    { label: 'Negative balances', value: 'negative-balances' },
    {
      label: 'Insurance estimates and no balance',
      value: 'insurance-estimates-and-no-balance',
    },
  ],
  onlyPatientsWith: [
    { label: 'Negative balances', value: 'negative-balances' },
    {
      label: 'Insurance estimates and no balance',
      value: 'insurance-estimates-and-no-balance',
    },
  ],
}

export const PAYMENT_PLAN_TYPES = [
  { label: 'Insurance', value: 'insurance' },
  { label: 'Patient', value: 'patient' },
  { label: 'Both', value: 'both' },
]

export const PAYMENT_PLANS_CHCKBX = [
  {
    label: 'Hide Completed Payment Plans',
    value: 'hide-completed-payment-plans',
  },
  { label: 'Show Family Balance', value: 'show-family-balance' },
  {
    label: 'Limit to Plans Created in Date Range',
    value: 'limit-to-plans-created-in-date-range',
  },
]

export const SHOW_INSURANCE_WRITE_OFFS = [
  {
    label: 'Using insurance payment date',
    value: 'using-insurance-payment-date',
  },
  { label: 'Using procedure date', value: 'using-procedure-date' },
  {
    label:
      'Using initial claim date for write-offs, insurance pay date for write-off adjustments',
    value:
      'using-initial-claim-date-for-write-offs-insurance-pay-date-for-write-off-adjustments',
  },
]

export const PPO_WRITE_OFFS_GROUP_BY = [
  { label: 'Individual Claims', value: 'individual-claims' },
  { label: 'Group by Carrier', value: 'group-by-carrier' },
]

export const REPORT_TYPE = [
  { label: 'Detailed Report', value: 'detailed-report' },
  { label: 'Totals Report', value: 'totals-report' },
]

export const ORDER_PRESENTED = [
  { label: 'First Presented', value: 'first-presented' },
  { label: 'Last Presented', value: 'last-presented' },
]

export const USER_DISPLAYED = [
  { label: 'Presenter', value: 'presenter' },
  { label: 'Entry User', value: 'entry-user' },
]

export const CALCULATED_PROD = [
  { label: 'Gross Production', value: 'gross-production' },
  { label: 'Net Production', value: 'net-production' },
]

export const PROC_NOT_BILLED_TO_INS_CB = [
  {
    label: 'Show Procedures Completed Before Insurance Added',
    value: 'show-proc-completed-before-insurance-added',
  },
  { label: 'Show Procedures In Process', value: 'show-proc-in-process' },
  {
    label: 'Automatically Group Procedures',
    value: 'automatically-group-proc',
  },
]

export const UNEARNED_TYPES = [
  { label: 'All', value: 'all' },
  { label: 'Prepayment', value: 'prepayment' },
  { label: 'Treat Plan Prepayment', value: 'treat-plan-prepayment' },
  { label: 'Payment Plan Prepay', value: 'payment-plan-prepay' },
]

export const UNEARNED_ALLOCATION_CB = [
  { label: 'Show Provider Column', value: 'show-provider-column' },
  {
    label: 'Exclude Families With a Net $0.00 Unearned Income Balance',
    value: 'exclude-families-with-a-net-0-unearned-income-balance',
  },
]

export const PATIENT_STATUS = [
  { label: 'All', value: 'all' },
  { label: 'Patient', value: 'patient' },
  { label: 'NonPatient', value: 'nonpatient' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Archived', value: 'archived' },
  { label: 'Deceased', value: 'deceased' },
  { label: 'Prospective', value: 'prospective' },
]

export const APPT_REPORTS_CB = [
  { label: 'Show Recall Appointments', value: 'show-recall-appointments' },
  {
    label: 'Show New Patient Appointments',
    value: 'show-new-patient-appointments',
  },
  { label: 'Show ASAP', value: 'show-asap' },
  {
    label: 'Show Existing Patient Appointments',
    value: 'show-existing-patient-appointments',
  },
]

export const APPT_DD = [
  { label: 'Appointment Date', value: 'appointment-date' },
  { label: 'Appointment Date Created', value: 'appointment-date-created' },
]

export const BROKEN_APPT_BY = [
  { label: 'Adjustments', value: 'adjustments' },
  { label: 'Appointment Status', value: 'appointment-status' },
]

export const NEW_PATIENTS_CB = [
  {
    label:
      "Include address information. Doesn't fit easily on a printout, but useful if you are exporting for letter merge.",
    value: 'include-address-information',
  },
  {
    label: 'Exclude patients with no production.',
    value: 'exclude-patients-with-no-production',
  },
]

export const REFERRAL_TYPE = [
  { label: 'Referral To', value: 'referral-to' },
  { label: 'Referral From', value: 'referral-from' },
  { label: 'Referral Custom', value: 'referral-custom' },
]

export const SEARCH_BY = [
  { label: 'Number', value: 'number' },
  { label: 'Last name', value: 'last-name' },
  { label: 'First name', value: 'first-name' },
  { label: 'Middle name', value: 'middle-name' },
  { label: 'Preferred', value: 'preferred' },
]

export const TOOLBARS = [
  'Undo',
  'Redo',
  'Bold',
  'Italic',
  'Underline',
  'StrikeThrough',
  'Indent',
  'Outdent',
]

export const FEE_SCHEDULE = [
  { label: 'Capital Preferred Patient', value: 'capital-preferred-patient' },
  { label: 'Co-NC Dental Discount', value: 'co-nc-dental-discount' },
  { label: 'MedDent Preferred', value: 'meddent-preferred' },
  { label: 'Medicaid Fees 2023', value: 'medicaid-fees-2023' },
  { label: 'NC Medicaid', value: 'nc-medicaid' },
  { label: 'Office Fees', value: 'office-fees' },
  { label: 'Office Fees 2023', value: 'office-fees-2023' },
  { label: 'MedDent Patient', value: 'meddent-patient' },
  { label: 'MedDent Patient Copay', value: 'meddent-patient-copay' },
  { label: 'Azure Allowed Non-PP', value: 'azure-allowed-non-pp' },
  { label: 'MedDent Fixed', value: 'meddent-fixed' },
]

export const REFERRALS_RAW = [
  { label: 'All', value: 'all' },
  { label: 'This Month', value: 'this-month' },
  { label: 'Last 3 Months', value: 'last-3-months' },
  { label: 'Last 6 Months', value: 'last-6-months' },
]

export const REFERRALS_ANALYSIS_CB = [
  {
    label:
      'Include address information. Useful if you are exporting for letter merge.',
    value: 'include-address-information',
  },
  { label: 'Only include new patients.', value: 'only-include-new-patients' },
]

export const CALENDAR_YEAR = [
  { label: 'January', value: 'january' },
  { label: 'February', value: 'february' },
  { label: 'March', value: 'march' },
  { label: 'April', value: 'april' },
  { label: 'May', value: 'may' },
  { label: 'June', value: 'june' },
  { label: 'July', value: 'july' },
  { label: 'August', value: 'august' },
  { label: 'September', value: 'september' },
  { label: 'October', value: 'october' },
  { label: 'November', value: 'november' },
  { label: 'December', value: 'december' },
]

export const TX_FINDER_CB = [
  {
    label: 'Include Hidden Billing Types',
    value: 'include-hidden-billing-types',
  },
  { label: 'Use Treating Provider', value: 'use-treating-provider' },
  {
    label: 'Assume Procedures Are General',
    value: 'assume-procedures-are-general',
  },
  {
    label: 'Include Secondary Insurance and No Insurance',
    value: 'include-secondary-insurance-and-no-insurance',
  },
  {
    label: 'Include Patients With Upcoming Appointments',
    value: 'include-patients-with-upcoming-appointments',
  },
]

export const CONFIRMATION_STATUS = [
  { label: 'Unconfirmed', value: 'unconfirmed' },
  { label: 'Confirmed', value: 'confirmed' },
  { label: 'Arrived', value: 'arrived' },
  { label: 'Ready To Go Back', value: 'ready-to-go-back' },
  { label: 'In Treatment Room', value: 'in-treatment-room' },
  { label: 'Check Out', value: 'check-out' },
  { label: 'Left Message', value: 'left-message' },
  { label: 'Disconnected', value: 'disconnected' },
  { label: 'E-mailed', value: 'e-mailed' },
  { label: 'Texted', value: 'texted' },
  { label: 'eConfirmSent', value: 'econfirm-sent' },
  { label: 'eConfirmCallBack', value: 'econfirm-callback' },
  { label: 'eConfirmFailure', value: 'econfirm-failure' },
  { label: 'Created From Web Sched', value: 'created-from-web-sched' },
  { label: 'Out The Door', value: 'out-the-door' },
]

export const WEB_SCHED_APPT_TYPES = [
  { label: 'Show Recall Appointments', value: 'show-recall-appointments' },
  {
    label: 'Show New Patient Appointments',
    value: 'show-new-patient-appointments',
  },
  { label: 'Show ASAP Appointments', value: 'show-asap-appointments' },
  {
    label: 'Show Existing Patient Appointments',
    value: 'show-existing-patient-appointments',
  },
]

export const AUTO_PROCESSED_RESULT = [
  { label: 'Semi-Automatic Incomplete', value: 'semi-automatic-incomplete' },
  { label: 'Semi-Automatic Complete', value: 'semi-automatic-complete' },
  { label: 'Fully-Automatic Incomplete', value: 'fully-automatic-incomplete' },
  { label: 'Fully-Automatic Complete', value: 'fully-automatic-complete' },
]

export const PRODUCTION_INCOME = [
  {
    field: 'today',
    header: 'Today',
  },
  {
    field: 'yesterday',
    header: 'Yesterday',
  },
  {
    field: 'thisMonth',
    header: 'This Month',
  },
  {
    field: 'lastMonth',
    header: 'Last Month',
  },
  {
    field: 'thisYear',
    header: 'This Year',
  },
  {
    field: 'moreOptions',
    header: 'More Options',
  },
  {
    field: 'monthlyProdGoal',
    header: 'Monthly Production Goal',
  },
  {
    field: 'providerPayrollSummary',
    header: 'Provider Payroll Summary',
  },
  {
    field: 'providerPayrollDetails',
    header: 'Provider Payroll Details',
  },
]

export const WEEKDAYS = DAY_ORDER.slice(0, 5) as IWorkingHours['day_of_week'][]

export const ASSIGNED_DEVICES: { type: string; label: string }[] = [
  { type: 'main_phone_line', label: 'Main phone line' },
  { type: 'emergency_phone_line', label: 'Emergency phone line' },
]

export const CONTACT_KEYS = ['call', 'sms'] as const

export const CARRIERS = ['AT&T', 'Verizon', 'T-Mobile', 'Other']

export const REROUTE_CALL_RING_TYPE_OPTIONS = [
  { label: 'Simultaneous', value: 'simultaneous' },
  { label: 'Round robin', value: 'round_robin' },
]

export const REROUTE_CALL_IF_NO_ANSWER_OPTIONS = [
  { label: 'Send to voicemail', value: 'voicemail' },
  { label: 'Text to speech', value: 'tts' },
  { label: 'AI receptionist', value: 'ai_receptionist' },
  { label: 'Hang up', value: 'hang_up' },
]

export const REROUTE_CALL_YES_NO_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
]

export const VOICEMAIL_AFTER_RECORDING_OPTIONS = [
  { label: 'End call', value: 'end_call' },
  { label: 'Beep once', value: 'beep_once' },
]

export const STEP_PANEL_TEAM_OPTIONS = [
  { label: 'Front desk', value: 'front_desk' },
  { label: 'Billing', value: 'billing' },
  { label: 'Clinical', value: 'clinical' },
]

export type StepPanelHoldMusicOption = {
  label: string
  value: string
  previewSrc?: string
}

export const STEP_PANEL_HOLD_MUSIC_OPTIONS: StepPanelHoldMusicOption[] = [
  {
    label: 'Default',
    value: 'default',
    previewSrc: '/call-flow/hold-default.wav',
  },
  {
    label: 'Calm hold',
    value: 'calm',
    previewSrc: '/call-flow/hold-calm.wav',
  },
  { label: 'Custom', value: 'custom' },
  { label: 'None', value: 'none' },
]

export const getStepPanelHoldMusicPreviewSrc = (
  holdMusicId: string | undefined | null,
): string | undefined => {
  if (!holdMusicId || holdMusicId === 'none' || holdMusicId === 'custom') {
    return undefined
  }
  return STEP_PANEL_HOLD_MUSIC_OPTIONS.find((o) => o.value === holdMusicId)
    ?.previewSrc
}

export const STEP_PANEL_TIMEOUT_OPTIONS = [
  { label: 'Voicemail', value: 'voicemail' },
  { label: 'Reroute', value: 'reroute' },
  { label: 'AI receptionist', value: 'ai_receptionist' },
  { label: 'Hang up', value: 'hang_up' },
]

export const BLOCK_REASON_PRESET_VALUES = [
  'Spam',
  'Robocall / Auto-dialer',
  'Scam or Fraud',
  'Harassment or Abuse',
  'Unwanted Sales Calls',
  'Wrong Number',
  'Repeated Calls',
  'Suspicious Activity',
  'Do Not Contact Request',
  'Other',
] as const
